import PatientInfo from './PatientInfo'

export default PatientInfo



// WEBPACK FOOTER //
// ./src/legacy/components/PatientInfo/index.js